import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { classCombine } from 'tradevan-ui/consts';

import { MenuItemProps } from '../Menu/type';

/** 產生Menu的內容 */
const MenuItem = (props: MenuItemProps) => {
  const { data } = props;
  // const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState('');
  // const pathName = window.location.pathname;
  // TODO RELOAD的時候展開
  return (
    <li
      style={{ cursor: 'pointer' }}
      className={classCombine(open ? 'menuitem-active' : '')}
    >
      <a
        href="##"
        onClick={(e) => {
          e.preventDefault();
          setOpen((prev) => !prev);
        }}
        data-toggle="collapse"
      >
        <i className="icon-file-lines1" />
        <span> {data.text} </span>
        <span className="menu-arrow" />
      </a>
      <Collapse in={open}>
        <div>
          <ul className="nav-second-level">
            {data.children?.map((v) => {
              return (
                <li
                  key={v.url}
                  className={classCombine(
                    selectedUrl === v.url ? 'menuitem-active' : '',
                  )}
                >
                  <Link
                    to={v.url}
                    title={v.text}
                    onClick={() => {
                      setSelectedUrl(v.url);
                    }}
                  >
                    {v.text}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </Collapse>
    </li>
  );
};

export default MenuItem;
